export const buildDraftedMessageAgentPayload = ({
    label,
    confirmationPrefix,
    confirmationPayload,
}: {
    label: string;
    confirmationPrefix: string;
    confirmationPayload: Record<string, unknown>;
}): string =>
    `${label}\n${confirmationPrefix} ${JSON.stringify(confirmationPayload)}`;

const DRAFTED_MESSAGE_CONFIRMED_PREFIX_PATTERN = /\n\[[^\]]+-confirmed\]\s/;

export const stripDraftedMessageMachineLine = (message: string): string => {
    const match = DRAFTED_MESSAGE_CONFIRMED_PREFIX_PATTERN.exec(message);
    if (match?.index != null) {
        return message.slice(0, match.index).trimEnd();
    }

    return message;
};

/** Returns the member-visible text for a stored drafted-message confirmation. */
export const formatDraftedMessageUserMessageForDisplay = (
    text: string,
): string => {
    if (!DRAFTED_MESSAGE_CONFIRMED_PREFIX_PATTERN.test(text)) {
        return text;
    }

    return stripDraftedMessageMachineLine(text);
};
